import React from 'react';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';

const OrderLinesExpandListTemplate = ({
	viewStore,
	viewStore: { data, listStore, tableData, queryUtility, noDataItem, change, loading },
}) => {
	if (loading) return null;
	return (
		<React.Fragment>
			<BaasicTable
				{...{
					listStore,
					data,
					tableData,
					queryUtility,
					viewStore,
					noDataItem,
					showImage: false,
					change,
				}}
				actions={viewStore}
			/>
			<ReactTooltip />
		</React.Fragment>
	);
};

export default defaultTemplate(OrderLinesExpandListTemplate);
